import React from 'react';
import { motion } from 'framer-motion';
import { Hammer, Home, Layers, ChefHat, Boxes, PaintRoller, Wrench, Ruler } from 'lucide-react';
import { SectionLabel } from './SectionLabel';
const SERVICES = [{
  icon: Home,
  title: 'Interior Renovations',
  copy: 'Full-room and whole-home remodels, reconfigured layouts, and refined finish work.'
}, {
  icon: Hammer,
  title: 'Exterior Improvements',
  copy: 'Siding, trim, decks, and repairs that protect the home and elevate the curb view.'
}, {
  icon: Layers,
  title: 'Flooring & Carpet',
  copy: 'Hardwood, tile, and carpet installation with precise transitions and level substrates.'
}, {
  icon: ChefHat,
  title: 'Kitchens & Baths',
  copy: 'Upgrades built around how you actually live — from tile detail to fixture selection.'
}, {
  icon: Boxes,
  title: 'Cabinetry & Built-Ins',
  copy: 'Custom cabinet installation, shelving, and millwork tailored to the room.'
}, {
  icon: PaintRoller,
  title: 'Interior & Exterior Painting',
  copy: 'Careful prep, clean lines, and durable coatings that hold up season after season.'
}, {
  icon: Wrench,
  title: 'Repairs & Maintenance',
  copy: 'Dependable general repairs and ongoing upkeep handled by one accountable team.'
}, {
  icon: Ruler,
  title: 'Custom Projects',
  copy: 'One-off builds and full remodels, planned and managed end to end.'
}];
export function ServicesSection() {
  return <section id="services" className="relative w-full bg-bone-50 py-24 sm:py-32" aria-labelledby="services-heading" data-id="element-156" data-mp="31a8dzsymu4wg">
      <div className="mx-auto max-w-[1320px] px-6 lg:px-10" data-id="element-157" data-mp="3fb1agj8hva27">
        <div className="grid gap-12 lg:grid-cols-12" data-id="element-158" data-mp="3aa3wkiuip26i">
          <div className="lg:col-span-5" data-id="element-159" data-mp="3achr8qlaccdj">
            <SectionLabel data-id="element-160" data-mp="uig1yu2z7lqv">What We Do</SectionLabel>
            <h2 id="services-heading" className="mt-7 font-display text-4xl font-light leading-[1.05] text-pine-950 sm:text-5xl" data-id="element-161" data-mp="ulc0ajiqkcfu">
              Full-service construction, delivered with a single standard.
            </h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7" data-id="element-162" data-mp="3o9nsfrk39mdf">
            <p className="text-base leading-relaxed text-pine-950/70" data-id="element-163" data-mp="3scaq493fy1ij">
              At Taylor Company we deliver full-service construction solutions
              designed to enhance the beauty, function, and value of your
              property. We combine skilled craftsmanship with dependable service
              to bring your vision to life — inside and out.
            </p>
            <p className="mt-5 text-sm leading-relaxed text-pine-950/50" data-id="element-164" data-mp="39mb6i1qddemi">
              Our services include, but are not limited to, the work below. If
              your project isn't listed, ask — we manage every phase from
              planning through finishing.
            </p>
          </div>
        </div>

        <div className="mt-16 grid grid-cols-1 gap-px overflow-hidden rounded-2xl border border-pine-900/10 bg-pine-900/10 sm:grid-cols-2 lg:grid-cols-4" data-id="element-165" data-mp="2lwgqjbar79y1">
          {SERVICES.map((service, i) => <motion.article key={service.title} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.6,
          delay: i % 4 * 0.06
        }} className="group relative bg-bone-50 p-8 transition-colors duration-300 hover:bg-pine-950" data-id="element-166" data-mp="29dmk5d6n1cyw" data-mpi={i}>
              <service.icon className="h-5 w-5 text-pine-700 transition-colors duration-300 group-hover:text-pine-200" aria-hidden="true" data-id="element-167" data-mp="1qn4vbjoxf1it" />
              <h3 className="mt-8 font-display text-2xl font-normal leading-snug text-pine-950 transition-colors duration-300 group-hover:text-bone-50" data-id="element-168" data-mp="1gpqq6g8gdz5t">
                {service.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-pine-950/60 transition-colors duration-300 group-hover:text-bone-100/70" data-id="element-169" data-mp="17p0ynoq86uxw">
                {service.copy}
              </p>
            </motion.article>)}
        </div>
      </div>
    </section>;
}